import { trigger, transition, style, animate } from '@angular/animations';

export type AnimationStep = 'slideOut' | 'slideIn' | 'fadeOut';

export const snackbarAnimation = trigger('slideInOut', [
  transition(
    ':enter',
    [
      style({ transform: '{{direction}}' }),
      animate('200ms ease-in', style({ transform: 'translateY(0%)' })),
    ],
    { params: { direction: '' } }
  ),
  transition('* => slideOut', [animate('200ms ease-in', style({ transform: '{{direction}}' }))], {
    params: { direction: 'translateY(-100%)' },
  }),
  transition('* => fadeOut', animate('200ms', style({ opacity: 0 }))),
]);
